// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6d1d0e58","134":"91680ff0","230":"ec2b62f5","307":"71231a9f","376":"3b47bc6d","381":"27464b3a","771":"050c2d98","992":"4c4fd3fb"}[chunkId] + ".chunk.js";
};